import React from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { LogOut, Home, CalendarDays, Banknote } from 'lucide-react';
import { BUILDBROZ_LOGO_URL } from '../branding';

const tabs = [
  { label: 'Home', path: '/workforce/home', icon: Home },
  { label: 'History', path: '/workforce/history', icon: CalendarDays },
  { label: 'Pay', path: '/workforce/pay', icon: Banknote },
];

const HEADER_BG =
  'https://static.prod-images.emergentagent.com/jobs/e28240eb-89e7-4e54-9741-7cd92399b327/images/2c72b3540c478026859db585ad1d3143a7ef4e4590501cdf591e2e9c6060491b.png';

export const WorkforceBrand = ({ small }) => (
  <div className="flex items-center gap-2.5">
    <img src={BUILDBROZ_LOGO_URL} alt="BuildBroz" className={`${small ? 'h-9 w-9' : 'h-12 w-12'} object-contain mix-blend-screen`} />
    <div>
      <div className={`text-white font-brand font-black ${small ? 'text-base' : 'text-xl'} tracking-tight leading-none`}>BUILD<span className="text-[#D4AF37]">BROZ</span></div>
      <div className="text-[8px] text-gray-400 uppercase tracking-[0.25em] font-brand mt-0.5">Workforce Portal</div>
    </div>
  </div>
);

export const goldCard = 'rounded-2xl border border-gray-800 bg-gradient-to-b from-[#161616] to-[#0C0C0C]';

export const CircleIcon = ({ icon: Icon, size = 'md' }) => (
  <span className={`${size === 'lg' ? 'h-12 w-12' : 'h-9 w-9'} rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center shrink-0`}>
    <Icon size={size === 'lg' ? 20 : 16} className="text-[#D4AF37]" strokeWidth={1.75} />
  </span>
);

export const EmployeeShell = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  if (!localStorage.getItem('employee_token')) return <Navigate to="/workforce" replace />;
  return (
    <div className="min-h-screen bg-[#050505] pb-28 relative">
      <div className="absolute top-0 inset-x-0 h-72 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${HEADER_BG})` }} />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-[#050505]" />
      </div>
      <header className="relative z-20 px-4 pt-4 pb-2 flex items-center justify-between max-w-lg mx-auto w-full">
        <WorkforceBrand small />
        <button onClick={() => { localStorage.removeItem('employee_token'); navigate('/workforce'); }}
          className="flex items-center gap-2 text-sm text-gray-200 border border-[#D4AF37]/50 rounded-xl px-4 py-2 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] transition-colors" data-testid="employee-logout-btn">
          <LogOut size={15} className="text-[#D4AF37]" /> Log out
        </button>
      </header>
      <main className="relative z-10 max-w-lg mx-auto px-4 py-5">{children}</main>
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-black/95 backdrop-blur border-t border-[#D4AF37]/30">
        <div className="max-w-lg mx-auto grid grid-cols-3">
          {tabs.map((t) => {
            const active = location.pathname === t.path;
            return (
              <button key={t.path} onClick={() => navigate(t.path)} data-testid={`workforce-tab-${t.label.toLowerCase()}`}
                className={`relative flex flex-col items-center gap-1 py-3.5 text-[11px] font-brand font-bold uppercase tracking-wider transition-colors ${active ? 'text-[#D4AF37]' : 'text-gray-500 hover:text-gray-300'}`}>
                {active && <span className="absolute top-0 h-[3px] w-12 rounded-b bg-[#D4AF37]" />}
                <t.icon size={20} /> {t.label}
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};
